import { loadStripe } from '@stripe/stripe-js';

const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY as string | undefined;

if (!key && import.meta.env.DEV) {
  console.warn('[Stripe] VITE_STRIPE_PUBLIC_KEY manquante — paiements désactivés');
}

export const stripePromise = key ? loadStripe(key) : null;
